(function () {
    'use strict';

    angular
        .module('businessPlanExplorerModule', [
            'businessPlanningModule',
            'services.permission',
            'gov.directives'
        ]);
})();
